var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen flex flex-col"},[_c('navbar'),_vm._v("\n\n    Meet our chasers...\n\n    "),_c('page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }